import { Link } from '@inertiajs/react';
import type { School } from '../../types';
import { SchoolItem } from '../school-item/school-item';

import styles from './school-list.module.css';

type Props = {
  prefecture: string;
  schools: Array<School>;
};

export function SchoolList(props: Props) {
  const { schools, prefecture } = props;

  return (
    <div className={styles.root}>
      <header className={styles.header}>
        <h1 className={styles.titlejp}>{prefecture}</h1>
        {schools.length > 0 && (
          <h2 className={styles.title}>
            {schools.length} school{schools.length === 1 ? '' : 's'} found in the {prefecture} prefecutre
          </h2>
        )}
      </header>

      {schools.length === 0 && (
        <div className={styles.noResultsWrapper}>
          <div className={styles.noResults}>Hmm, there were no schools in {prefecture} prefecutre</div>
          <Link href="/" prefetch>
            Return to prefecture list
          </Link>
        </div>
      )}
      <div className={styles.items}>
        {schools.map((school) => (
          <div className={styles.item} key={school.id}>
            <SchoolItem school={school} />
          </div>
        ))}
      </div>
    </div>
  );
}
